"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AvatarDescriptionEnum;
(function (AvatarDescriptionEnum) {
    // K-5
    AvatarDescriptionEnum["JOE"] = "Cartoon image of a smiling, one-eyed, gold monster standing up";
    AvatarDescriptionEnum["ROCKY"] = "Cartoon image of a smiling, one-eyed, blue monster standing up";
    AvatarDescriptionEnum["HAPPY"] = "Cartoon image of a smiling, three-eyed, lime green monster standing up";
    AvatarDescriptionEnum["DAISY"] = "Cartoon image of a smiling, two-eyed, magenta monster standing up";
    AvatarDescriptionEnum["MEL"] = "Cartoon image of a smiling, three-eyed, purple monster standing up";
    AvatarDescriptionEnum["JUNE"] = "Cartoon image of a smiling, three-eyed, turquoise monster standing up";
    AvatarDescriptionEnum["SID"] = "Cartoon image of a smiling, three-eyed, green monster standing up";
    AvatarDescriptionEnum["ROSE"] = "Cartoon image of a smiling, two-eyed, violet monster standing up";
    AvatarDescriptionEnum["LILY"] = "Cartoon image of a smiling, two-eyed, red monster standing up";
    AvatarDescriptionEnum["JOSEPH"] = "Cartoon image of a smiling, one-eyed, red monster standing up";
    AvatarDescriptionEnum["HANK"] = "Cartoon image of a smiling, one-eyed, yellow monster standing up";
    AvatarDescriptionEnum["JG"] = "Illustration of 3-eyed purple monster.";
    AvatarDescriptionEnum["ROCKET"] = "Illustration of 1-eyed green monster.";
    AvatarDescriptionEnum["SPARKLE"] = "Illustration of 3-eyed aqua blue monster.";
    AvatarDescriptionEnum["SUNNY"] = "Illustration of 1-eyed blue monster.";
    AvatarDescriptionEnum["HARRYK5"] = "Illustration of 2-eyed purple monster.";
    AvatarDescriptionEnum["TULIP"] = "Illustration of 3-eyed green monster.";
    AvatarDescriptionEnum["CLYDE"] = "Illustration of 1-eyed light orange monster.";
    AvatarDescriptionEnum["CRABBY"] = "Illustration of 2-eyed orange crab monster.";
    AvatarDescriptionEnum["CHUCK"] = "Illustration of 1-eyed red monster.";
    AvatarDescriptionEnum["FUZZY"] = "Illustration of 1-eyed yellow bug monster.";
    // 6-8
    AvatarDescriptionEnum["OTTO"] = "Raccoon with glasses";
    AvatarDescriptionEnum["TANGO"] = "Giraffe blowing a bubble";
    AvatarDescriptionEnum["SMOKY"] = "Lion with mane";
    AvatarDescriptionEnum["GADGET"] = "Dog with floppy ears";
    AvatarDescriptionEnum["MEG"] = "Panda bear";
    AvatarDescriptionEnum["RED"] = "Bear waving";
    AvatarDescriptionEnum["SKY"] = "White Bunny";
    AvatarDescriptionEnum["MO"] = "White and tan dog";
    AvatarDescriptionEnum["NANO"] = "Koala bear";
    AvatarDescriptionEnum["HARRY"] = "Tan labrador retriever dog";
    AvatarDescriptionEnum["SMILEY"] = "Kitten with headphones";
    AvatarDescriptionEnum["PIXEL"] = "Photo of Small Baby Chick.";
    AvatarDescriptionEnum["RUBY"] = "Photo of White cat with Sunglasses.";
    AvatarDescriptionEnum["SPIKE"] = "Photo of Small Porcupine.";
    AvatarDescriptionEnum["IGGY"] = "Photo of Green Iguana.";
    AvatarDescriptionEnum["MILES"] = "Photo of Black French Bulldog with Sunglasses.";
    AvatarDescriptionEnum["REX"] = "Photo of T-Rex Dinosaur.";
    AvatarDescriptionEnum["KAI"] = "Photo of Small Blowfish.";
    AvatarDescriptionEnum["OAKLEY"] = "Photo of Colorful Parrot.";
    AvatarDescriptionEnum["LENNY"] = "Photo of Dinosaur.";
    AvatarDescriptionEnum["ZELDA"] = "Photo of Owl.";
    // 9-12
    AvatarDescriptionEnum["CAT"] = "Branded Avatar";
    AvatarDescriptionEnum["GRIZZLY"] = "Photo of a bear portrait";
    AvatarDescriptionEnum["LION"] = "Photo of a lion head portrait";
    AvatarDescriptionEnum["SHARK"] = "Photo of a shark portrait";
    AvatarDescriptionEnum["MONKEY"] = "Photo of a monkey portrait";
    AvatarDescriptionEnum["HORSE"] = "Photo of a horse head portrait";
    AvatarDescriptionEnum["PANDA"] = "Illustration of a panda bear portrait";
    AvatarDescriptionEnum["ELK"] = "Illustration of a elk portrait";
    AvatarDescriptionEnum["FOX"] = "Illustration of a fox portrait";
    AvatarDescriptionEnum["RACCOON"] = "Illustration of a raccoon portrait";
    AvatarDescriptionEnum["GIRAFFE"] = "Illustration of a giraffe portrait";
    AvatarDescriptionEnum["ACE"] = "Photo of a dog underwater.";
    AvatarDescriptionEnum["CALVIN"] = "Photo of colorful lizard.";
    AvatarDescriptionEnum["DASH"] = "Photo of T-Rex Dinosaur.";
    AvatarDescriptionEnum["DENVER"] = "Photo of squirrel with cracker.";
    AvatarDescriptionEnum["HARLEY"] = "Photo of mother and baby toad.";
    AvatarDescriptionEnum["OLLIE"] = "Illustration of silver wolf.";
    AvatarDescriptionEnum["DUKE"] = "Illustration of French bulldog.";
    AvatarDescriptionEnum["HUX"] = "Illustration of skunk with glasses.";
    AvatarDescriptionEnum["REMY"] = "Illustration of owl.";
    AvatarDescriptionEnum["SONNY"] = "Illustration of llama.";
    // ABLD
    AvatarDescriptionEnum["ABLD_ALLIGATOR"] = "Photo of a alligator portrait";
    AvatarDescriptionEnum["ABLD_BIRD"] = "Photo of a bird portrait";
    AvatarDescriptionEnum["ABLD_BROWN_BEAR"] = "Photo of a brown bear portrait";
    AvatarDescriptionEnum["ABLD_BUTTERFLY"] = "Photo of a butterfly portrait";
    AvatarDescriptionEnum["ABLD_CAT"] = "Photo of a cat portrait";
    AvatarDescriptionEnum["ABLD_CLOWNFISH"] = "Photo of a clownfish portrait";
    AvatarDescriptionEnum["ABLD_DOG"] = "Photo of a dog portrait";
    AvatarDescriptionEnum["ABLD_DOLPHIN"] = "Photo of a dolphin portrait";
    AvatarDescriptionEnum["ABLD_ELEPHANT"] = "Photo of a elephant portrait";
    AvatarDescriptionEnum["ABLD_FROG"] = "Photo of a frog portrait";
    AvatarDescriptionEnum["ABLD_GIRAFFE"] = "Photo of a giraffe portrait";
    AvatarDescriptionEnum["ABLD_GOLDFISH"] = "Photo of a goldfish portrait";
    AvatarDescriptionEnum["ABLD_GOOSE"] = "Photo of a goose portrait";
    AvatarDescriptionEnum["ABLD_HAMSTER"] = "Photo of a hamster portrait";
    AvatarDescriptionEnum["ABLD_HORSE"] = "Photo of a horse portrait";
    AvatarDescriptionEnum["ABLD_IGUANA"] = "Photo of a iguana portrait";
    AvatarDescriptionEnum["ABLD_KOALA_BEAR"] = "Photo of a koala bear portrait";
    AvatarDescriptionEnum["ABLD_LEOPARD"] = "Photo of a leopard portrait";
    AvatarDescriptionEnum["ABLD_LION"] = "Photo of a lion portrait";
    AvatarDescriptionEnum["ABLD_MONKEY"] = "Photo of a monkey portrait";
    AvatarDescriptionEnum["ABLD_ORCA_WHALE"] = "Photo of a orca whale portrait";
    AvatarDescriptionEnum["ABLD_PANDA_BEAR"] = "Photo of a panda bear portrait";
    AvatarDescriptionEnum["ABLD_PARROT"] = "Photo of a parrot portrait";
    AvatarDescriptionEnum["ABLD_PENGUIN"] = "Photo of a penguin portrait";
    AvatarDescriptionEnum["ABLD_RABBIT"] = "Photo of a rabbit portrait";
    AvatarDescriptionEnum["ABLD_RACOON"] = "Photo of a racoon portrait";
    AvatarDescriptionEnum["ABLD_SEA_TURTLE"] = "Photo of a sea turtle portrait";
    AvatarDescriptionEnum["ABLD_SEAHORSE"] = "Photo of a seahorse portrait";
    AvatarDescriptionEnum["ABLD_SHARK"] = "Photo of a shark portrait";
    AvatarDescriptionEnum["ABLD_SHEEP"] = "Photo of a sheep portrait";
    AvatarDescriptionEnum["ABLD_SHELL"] = "Photo of a shell portrait";
    AvatarDescriptionEnum["ABLD_SLOTH"] = "Photo of a sloth portrait";
    AvatarDescriptionEnum["ABLD_STARFISH"] = "Photo of a starfish portrait";
    AvatarDescriptionEnum["ABLD_TIGER"] = "Photo of a tiger portrait";
    AvatarDescriptionEnum["ABLD_TURTLE"] = "Photo of a turtle portrait";
    AvatarDescriptionEnum["ABLD_ZEBRA"] = "Photo of a zebra portrait";
})(AvatarDescriptionEnum || (AvatarDescriptionEnum = {}));
exports.default = AvatarDescriptionEnum;
